import React from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import EmptyItems from '../../../errors/common/EmptyItems';

const DocumentHistoryEmptyState = () => (
  <EmptyItems
    Icon={FileTextOutlined}
    title="Aucune modification enregistrée"
    className="w-full border border-gray-200"
  >
    <p>Ce document n'a pas encore fait l'objet d'une modification depuis l'activation de l'historique.</p>
  </EmptyItems>
);

export default DocumentHistoryEmptyState;
